import { combineReducers } from "redux";

import dummy from "./dummy";
import audiobookiBooks from "./audiobookiBooksReducer";
import { authentication } from "./authenticatedReducer";
import showUnactiveEmployees from "./showUnactiveEmployeesReducer";
import showDeletedUsers from "./showDeletedUsersReducer";
import showTokenType from "./showTokenTypesReducer";
import tableStateReducer from './tableStateReducer';
const reducer = combineReducers({
  dummy,
  audiobookiBooks,
  authentication,
  showUnactiveEmployees,
  showTokenType,
  showDeletedUsers,
  tableState: tableStateReducer,
});

export default reducer;
